
export default {
    name: "popup_intro_avatar",
    props: ["isLoading"],
    data(){
        return {
            selectedGender: null,
            isHoveringBtn: false,
        }
    },
    computed: {

    },
    mounted(){

    },
    methods: {
        onClickGoBtn(){
            this.$emit("update:isShowIntroPopup", false);
        },
    }
}
